// extracted by mini-css-extract-plugin
module.exports = {"title":"assessment_title__wgx7v","sub_title":"assessment_sub_title__cOJV8","margin":"assessment_margin__6PSZ5","btn":"assessment_btn__2PhhO"};